import '../../css/vehicle/_comparator.scss';
import Choices from "choices.js";
import comparatorVehicle from '../components/_comparator';

window.addEventListener('DOMContentLoaded', () => {
    let deleteButtons = document.getElementsByClassName('icon-close-delete');
    if(deleteButtons.length > 0) {
        deleteButtons.forEach((elt) => {
            const vehicleId = elt.dataset.vehicleId;

            elt.onclick = () => {
                comparatorVehicle(vehicleId).then(() => {
                    const dataSelector = `[data-vehicle-id="${vehicleId}"]`;
                    const toDelete     = document.querySelectorAll(dataSelector);

                    if(toDelete.length > 0) {
                        toDelete.forEach((elt) => {
                            elt.remove();
                        });
                    }
                }).then(() => {
                    const dataSelector = document.querySelectorAll('[data-vehicle-id]');

                    if(dataSelector.length === 0) {
                        document.getElementById('comparator_table').classList.add('d-none');
                        document.getElementById('comparator_empty').classList.remove('d-none');
                    }
                });
            };
        });
    }
});
